import { createAppSlice } from "../../app/createAppSlice";

const initialState = {
    "comments": [],
    "conceptCode": "",
    "conceptCommentsExpanded": false,
    "conceptDelete": false,
    "conceptJsonExpanded": false,
    "conceptMyVotesExpanded": false,
    "conceptName": "",
    "conceptOpenForVoting": false,
    "conceptPath": undefined,
    "conceptPathIndexes": undefined,
    "conceptPathString": undefined,
    "conceptSelected": undefined,
    "conceptVotesExpanded": false,
    "hasApprovalProperty": false,
    "initialScrolled": false,
    "myVotes": [],
    "newChildConcepts": [],
    "submitNewChildConcepts": false,
    "submitNewTopLevelConcepts": false,
    "termChanged": false,
    "termToNavigateTo": undefined,
    "votePermission": undefined,
    "votes": []
};

const codeSystemTermDetailSlice = createAppSlice({
    name: "codeSystemTermDetail",
    initialState,
    reducers: create => ({
        changeConceptCode: create.reducer((state, action) => {
            state.conceptCode = action.payload || "";
        }),
        changeConceptCommentsExpanded: create.reducer((state, action) => {
            state.conceptCommentsExpanded = action.payload || false;
        }),
        changeConceptDelete: create.reducer((state, action) => {
            state.conceptDelete = action.payload || false;
        }),
        changeConceptJsonExpanded: create.reducer((state, action) => {
            state.conceptJsonExpanded = action.payload || false;
        }),
        changeConceptMyVotesExpanded: create.reducer((state, action) => {
            state.conceptMyVotesExpanded = action.payload || false;
        }),
        changeConceptName: create.reducer((state, action) => {
            state.conceptName = action.payload || "";
        }),
        changeConceptOpenForVoting: create.reducer((state, action) => {
            state.conceptOpenForVoting = action.payload || "";
        }),
        changeConceptPath: create.reducer((state, action) => {
            state.conceptPath = action.payload || undefined;
        }),
        changeConceptPathIndexes: create.reducer((state, action) => {
            state.conceptPathIndexes = action.payload || undefined;
        }),
        changeConceptPathString: create.reducer((state, action) => {
            state.conceptPathString = action.payload || undefined;
        }),
        changeConceptSelected: create.reducer((state, action) => {
            state.conceptSelected = action.payload || undefined;
        }),
        changeConceptVotesExpanded: create.reducer((state, action) => {
            state.conceptVotesExpanded = action.payload || false;
        }),
        changeHasApprovalProperty: create.reducer((state, action) => {
            state.hasApprovalProperty = action.payload || false;
        }),
        changeInitialScrolled: create.reducer((state, action) => {
            state.initialScrolled = action.payload || false;
        }),
        changeNewChildConcepts: create.reducer((state, action) => {
            state.newChildConcepts = action.payload || [];
        }),
        changeSubmitNewChildConcepts: create.reducer((state, action) => {
            state.submitNewChildConcepts = action.payload || false;
        }),
        changeSubmitNewTopLevelConcepts: create.reducer((state, action) => {
            state.submitNewTopLevelConcepts = action.payload || false;
        }),
        changeTermChanged: create.reducer((state, action) => {
            state.termChanged = action.payload || false;
        }),
        changeTermComments: create.reducer((state, action) => {
            state.comments = action.payload || [];
        }),
        changeTermMyVotes: create.reducer((state, action) => {
            state.myVotes = action.payload || [];
        }),
        changeTermToNavigateTo: create.reducer((state, action) => {
            state.termToNavigateTo = action.payload || undefined;
        }),
        changeTermVotes: create.reducer((state, action) => {
            state.votes = action.payload || [];
        }),
        changeVotePermission: create.reducer((state, action) => {
            state.votePermission = action.payload ?? undefined;
        }),
    }),
    selectors: {
        selectConceptCode: state => state.conceptCode,
        selectConceptCommentsExpanded: state => state.conceptCommentsExpanded,
        selectConceptDelete: state => state.conceptDelete,
        selectConceptJsonExpanded: state => state.conceptJsonExpanded,
        selectConceptMyVotesExpanded: state => state.conceptMyVotesExpanded,
        selectConceptName: state => state.conceptName,
        selectConceptOpenForVoting: state => state.conceptOpenForVoting,
        selectConceptPath: state => state.conceptPath,
        selectConceptPathIndexes: state => state.conceptPathIndexes,
        selectConceptPathString: state => state.conceptPathString,
        selectConceptSelected: state => state.conceptSelected,
        selectConceptVotesExpanded: state => state.conceptVotesExpanded,
        selectHasApprovalProperty: state => state.hasApprovalProperty,
        selectInitialScrolled: state => state.initialScrolled,
        selectNewChildConcepts: state => state.newChildConcepts,
        selectSubmitNewChildConcepts: state => state.submitNewChildConcepts,
        selectSubmitNewTopLevelConcepts: state => state.submitNewTopLevelConcepts,
        selectTermChanged: state => state.termChanged,
        selectTermComments: state => state.comments,
        selectTermMyVotes: state => state.myVotes,
        selectTermToNavigateTo: state => state.termToNavigateTo,
        selectTermVotes: state => state.votes,
        selectVotePermission: state => state.votePermission
    },
})

export const { changeConceptCode, changeConceptCommentsExpanded,
    changeConceptDelete,
    changeConceptJsonExpanded, changeConceptMyVotesExpanded, changeConceptName, changeConceptOpenForVoting,
    changeConceptPath, changeConceptPathIndexes, changeConceptPathString, 
    changeConceptSelected, changeConceptVotesExpanded, changeHasApprovalProperty,
    changeInitialScrolled, changeNewChildConcepts,
    changeSubmitNewChildConcepts, changeSubmitNewTopLevelConcepts, 
    changeTermChanged, changeTermComments, changeTermMyVotes,
    changeTermToNavigateTo, changeTermVotes, changeVotePermission
} = codeSystemTermDetailSlice.actions

export const { selectConceptCode, selectConceptCommentsExpanded,
    selectConceptDelete,
    selectConceptJsonExpanded, selectConceptMyVotesExpanded, selectConceptName, selectConceptOpenForVoting,
    selectConceptPath, selectConceptPathIndexes, selectConceptPathString, 
    selectConceptSelected, selectConceptVotesExpanded, selectHasApprovalProperty,
    selectInitialScrolled, selectNewChildConcepts,
    selectSubmitNewChildConcepts, selectSubmitNewTopLevelConcepts, 
    selectTermChanged, selectTermComments, selectTermMyVotes,
    selectTermToNavigateTo, selectTermVotes, selectVotePermission
} = codeSystemTermDetailSlice.selectors

export default codeSystemTermDetailSlice